/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import styled from 'styled-components';
import { Form } from 'react-bootstrap';

export const FormCheck: any = styled(Form.Check)`
  .form-check-input:checked {
    background-color: #068a55;
  }
  .form-check-input:disabled {
    opacity: 1;
  }
  .form-check-input[disabled] ~ .form-check-label,
  .form-check-input:disabled ~ .form-check-label {
    opacity: 1;
  }
`;
